import React, { useEffect } from "react";
import "aos/dist/aos.css";
import FadeAnother from "../components/FadeAnother";
import ModelUpper from "../components/ModelUpper";
import Moment from "../components/Moment";
import ModelCreate from "../components/ModelCreate";
import ModelPicture from "../components/ModelPicture";

const Model = () => {
  return (
    <div className="Model">
      <div className="full_Screen">
        <FadeAnother />
      </div>

      <div className="px__Screen">
        <ModelUpper />
        <Moment />
        <ModelCreate />
        <ModelPicture />
      </div>
    </div>
  );
};

export default Model;
